<template>
  <div class="live">
    <!-- 主要内容区 -->
    <main class="max-w-7xl mx-auto px-4 py-8">
      <!-- 直播数据概览 -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <div class="bg-white rounded-lg shadow-md p-6">
          <div class="flex items-center">
            <div class="p-3 rounded-full bg-blue-100 text-blue-600">
              <i class="fas fa-video text-xl"></i>
            </div>
            <div class="ml-4">
              <p class="text-gray-500">当前直播</p>
              <p class="text-2xl font-bold">12</p>
            </div>
          </div>
        </div>
        <div class="bg-white rounded-lg shadow-md p-6">
          <div class="flex items-center">
            <div class="p-3 rounded-full bg-green-100 text-green-600">
              <i class="fas fa-users text-xl"></i>
            </div>
            <div class="ml-4">
              <p class="text-gray-500">在线观众</p>
              <p class="text-2xl font-bold">8,432</p>
            </div>
          </div>
        </div>
        <div class="bg-white rounded-lg shadow-md p-6">
          <div class="flex items-center">
            <div class="p-3 rounded-full bg-purple-100 text-purple-600">
              <i class="fas fa-gift text-xl"></i>
            </div>
            <div class="ml-4">
              <p class="text-gray-500">礼物收入</p>
              <p class="text-2xl font-bold">¥12,345</p>
            </div>
          </div>
        </div>
        <div class="bg-white rounded-lg shadow-md p-6">
          <div class="flex items-center">
            <div class="p-3 rounded-full bg-yellow-100 text-yellow-600">
              <i class="fas fa-comments text-xl"></i>
            </div>
            <div class="ml-4">
              <p class="text-gray-500">互动消息</p>
              <p class="text-2xl font-bold">23,456</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 搜索和筛选 -->
      <div class="bg-white rounded-lg shadow-md p-6 mb-8">
        <div class="flex flex-wrap items-center gap-4">
          <div class="flex-1">
            <div class="relative">
              <input 
                type="text" 
                placeholder="搜索直播标题、主播名称..." 
                class="w-full pl-10 pr-4 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
                v-model="searchQuery"
              >
              <i class="fas fa-search absolute left-3 top-3 text-gray-400"></i>
            </div>
          </div>
          <select 
            v-model="statusFilter" 
            class="border rounded-lg px-4 py-2 focus:outline-none focus:border-blue-500"
          >
            <option value="all">所有状态</option>
            <option value="live">直播中</option>
            <option value="ended">已结束</option>
            <option value="scheduled">未开始</option>
          </select>
          <select 
            v-model="categoryFilter" 
            class="border rounded-lg px-4 py-2 focus:outline-none focus:border-blue-500"
          >
            <option value="all">所有分类</option>
            <option value="game">游戏</option>
            <option value="music">音乐</option>
            <option value="dance">舞蹈</option>
            <option value="food">美食</option>
          </select>
          <button class="bg-gray-100 px-4 py-2 rounded-lg hover:bg-gray-200">
            <i class="fas fa-filter mr-2"></i>更多筛选
          </button>
          <button class="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700">
            <i class="fas fa-plus mr-2"></i>创建直播
          </button>
        </div>
      </div>

      <!-- 直播列表 -->
      <div class="space-y-6">
        <!-- 直播卡片 1 -->
        <div class="bg-white rounded-lg shadow-md overflow-hidden">
          <div class="flex">
            <div class="w-1/3">
              <div class="relative">
                <img src="https://images.unsplash.com/photo-1511512578047-dfb367046420?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60" alt="直播封面" class="w-full h-48 object-cover">
                <div class="absolute top-4 left-4">
                  <span class="bg-red-500 text-white px-2 py-1 rounded-full text-sm">直播中</span>
                </div>
                <div class="absolute bottom-4 left-4 flex items-center text-white">
                  <i class="fas fa-eye mr-1"></i>
                  <span class="text-sm">1.2K</span>
                </div>
              </div>
            </div>
            <div class="w-2/3 p-6">
              <div class="flex justify-between items-start mb-4">
                <div>
                  <h3 class="text-xl font-bold">王者荣耀排位赛</h3>
                  <p class="text-gray-600">主播：小美</p>
                </div>
                <div class="text-right">
                  <p class="text-sm text-gray-500">直播时长</p>
                  <p class="font-bold text-blue-600">2小时15分钟</p>
                </div>
              </div>
              <div class="grid grid-cols-4 gap-4 mb-4">
                <div class="text-center">
                  <p class="text-gray-500 text-sm">观众</p>
                  <p class="font-bold">1,234</p>
                </div>
                <div class="text-center">
                  <p class="text-gray-500 text-sm">礼物</p>
                  <p class="font-bold">¥3,456</p>
                </div>
                <div class="text-center">
                  <p class="text-gray-500 text-sm">互动</p>
                  <p class="font-bold">5,678</p>
                </div>
                <div class="text-center">
                  <p class="text-gray-500 text-sm">点赞</p>
                  <p class="font-bold">12,345</p>
                </div>
              </div>
              <div class="flex justify-between items-center">
                <div class="flex space-x-2">
                  <button class="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 text-sm">
                    <i class="fas fa-play mr-1"></i>观看直播
                  </button>
                  <button class="bg-gray-100 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-200 text-sm">
                    <i class="fas fa-chart-line mr-1"></i>数据分析
                  </button>
                </div>
                <div class="text-right">
                  <p class="text-sm text-gray-500">开始时间</p>
                  <p class="font-bold">14:30</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 直播卡片 2 -->
        <div class="bg-white rounded-lg shadow-md overflow-hidden">
          <div class="flex">
            <div class="w-1/3">
              <div class="relative">
                <img src="https://images.unsplash.com/photo-1511512578047-dfb367046420?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60" alt="直播封面" class="w-full h-48 object-cover">
                <div class="absolute top-4 left-4">
                  <span class="bg-green-500 text-white px-2 py-1 rounded-full text-sm">直播中</span>
                </div>
                <div class="absolute bottom-4 left-4 flex items-center text-white">
                  <i class="fas fa-eye mr-1"></i>
                  <span class="text-sm">856</span>
                </div>
              </div>
            </div>
            <div class="w-2/3 p-6">
              <div class="flex justify-between items-start mb-4">
                <div>
                  <h3 class="text-xl font-bold">美食探店vlog</h3>
                  <p class="text-gray-600">主播：阿杰</p>
                </div>
                <div class="text-right">
                  <p class="text-sm text-gray-500">直播时长</p>
                  <p class="font-bold text-green-600">1小时45分钟</p>
                </div>
              </div>
              <div class="grid grid-cols-4 gap-4 mb-4">
                <div class="text-center">
                  <p class="text-gray-500 text-sm">观众</p>
                  <p class="font-bold">856</p>
                </div>
                <div class="text-center">
                  <p class="text-gray-500 text-sm">礼物</p>
                  <p class="font-bold">¥1,234</p>
                </div>
                <div class="text-center">
                  <p class="text-gray-500 text-sm">互动</p>
                  <p class="font-bold">2,345</p>
                </div>
                <div class="text-center">
                  <p class="text-gray-500 text-sm">点赞</p>
                  <p class="font-bold">8,901</p>
                </div>
              </div>
              <div class="flex justify-between items-center">
                <div class="flex space-x-2">
                  <button class="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 text-sm">
                    <i class="fas fa-play mr-1"></i>观看直播
                  </button>
                  <button class="bg-gray-100 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-200 text-sm">
                    <i class="fas fa-chart-line mr-1"></i>数据分析
                  </button>
                </div>
                <div class="text-right">
                  <p class="text-sm text-gray-500">开始时间</p>
                  <p class="font-bold">16:00</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 直播卡片 3 -->
        <div class="bg-white rounded-lg shadow-md overflow-hidden">
          <div class="flex">
            <div class="w-1/3">
              <div class="relative">
                <img src="https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60" alt="直播封面" class="w-full h-48 object-cover">
                <div class="absolute top-4 left-4">
                  <span class="bg-gray-500 text-white px-2 py-1 rounded-full text-sm">已结束</span>
                </div>
                <div class="absolute bottom-4 left-4 flex items-center text-white">
                  <i class="fas fa-eye mr-1"></i>
                  <span class="text-sm">2.1K</span>
                </div>
              </div>
            </div>
            <div class="w-2/3 p-6">
              <div class="flex justify-between items-start mb-4">
                <div>
                  <h3 class="text-xl font-bold">美妆教程分享</h3>
                  <p class="text-gray-600">主播：小丽</p>
                </div>
                <div class="text-right">
                  <p class="text-sm text-gray-500">直播时长</p>
                  <p class="font-bold text-gray-600">3小时20分钟</p>
                </div>
              </div>
              <div class="grid grid-cols-4 gap-4 mb-4">
                <div class="text-center">
                  <p class="text-gray-500 text-sm">观众</p>
                  <p class="font-bold">2,156</p>
                </div>
                <div class="text-center">
                  <p class="text-gray-500 text-sm">礼物</p>
                  <p class="font-bold">¥5,678</p>
                </div>
                <div class="text-center">
                  <p class="text-gray-500 text-sm">互动</p>
                  <p class="font-bold">8,901</p>
                </div>
                <div class="text-center">
                  <p class="text-gray-500 text-sm">点赞</p>
                  <p class="font-bold">23,456</p>
                </div>
              </div>
              <div class="flex justify-between items-center">
                <div class="flex space-x-2">
                  <button class="bg-gray-600 text-white px-4 py-2 rounded-lg hover:bg-gray-700 text-sm">
                    <i class="fas fa-play mr-1"></i>查看回放
                  </button>
                  <button class="bg-gray-100 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-200 text-sm">
                    <i class="fas fa-chart-line mr-1"></i>数据分析
                  </button>
                </div>
                <div class="text-right">
                  <p class="text-sm text-gray-500">结束时间</p>
                  <p class="font-bold">18:20</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 分页 -->
      <div class="flex justify-center mt-8">
        <nav class="flex items-center space-x-2">
          <button class="px-3 py-1 rounded-lg border hover:bg-gray-100">
            <i class="fas fa-chevron-left"></i>
          </button>
          <button class="px-3 py-1 rounded-lg bg-blue-600 text-white">1</button>
          <button class="px-3 py-1 rounded-lg border hover:bg-gray-100">2</button>
          <button class="px-3 py-1 rounded-lg border hover:bg-gray-100">3</button>
          <span class="px-2">...</span>
          <button class="px-3 py-1 rounded-lg border hover:bg-gray-100">10</button>
          <button class="px-3 py-1 rounded-lg border hover:bg-gray-100">
            <i class="fas fa-chevron-right"></i>
          </button>
        </nav>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'LivePage',
  data() {
    return {
      searchQuery: '',
      statusFilter: 'all',
      categoryFilter: 'all'
    }
  }
}
</script>

<style scoped>
.live {
  background: #f5f5f5;
  min-height: calc(100vh - 64px);
}

.grid {
  display: grid;
}

.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

@media (min-width: 768px) {
  .md\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 1024px) {
  .lg\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

.gap-6 {
  gap: 1.5rem;
}

.gap-4 {
  gap: 1rem;
}

.mb-8 {
  margin-bottom: 2rem;
}

.mb-4 {
  margin-bottom: 1rem;
}

.mt-8 {
  margin-top: 2rem;
}

.p-6 {
  padding: 1.5rem;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.mr-2 {
  margin-right: 0.5rem;
}

.mr-1 {
  margin-right: 0.25rem;
}

.text-xl {
  font-size: 1.25rem;
}

.text-2xl {
  font-size: 1.5rem;
}

.font-bold {
  font-weight: 700;
}

.text-gray-500 {
  color: #6b7280;
}

.text-gray-600 {
  color: #4b5563;
}

.text-blue-600 {
  color: #2563eb;
}

.text-green-600 {
  color: #16a34a;
}

.text-purple-600 {
  color: #9333ea;
}

.text-yellow-600 {
  color: #ca8a04;
}

.text-red-500 {
  color: #ef4444;
}

.text-green-500 {
  color: #10b981;
}

.text-gray-500 {
  color: #6b7280;
}

.text-white {
  color: #ffffff;
}

.bg-blue-100 {
  background-color: #dbeafe;
}

.bg-green-100 {
  background-color: #dcfce7;
}

.bg-purple-100 {
  background-color: #f3e8ff;
}

.bg-yellow-100 {
  background-color: #fef3c7;
}

.bg-blue-600 {
  background-color: #2563eb;
}

.bg-gray-100 {
  background-color: #f3f4f6;
}

.bg-gray-600 {
  background-color: #4b5563;
}

.bg-red-500 {
  background-color: #ef4444;
}

.bg-green-500 {
  background-color: #10b981;
}

.bg-gray-500 {
  background-color: #6b7280;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.rounded-full {
  border-radius: 9999px;
}

.shadow-md {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.border {
  border-width: 1px;
}

.focus\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\:border-blue-500:focus {
  border-color: #2563eb;
}

.hover\:bg-gray-200:hover {
  background-color: #e5e7eb;
}

.hover\:bg-blue-700:hover {
  background-color: #1d4ed8;
}

.hover\:bg-gray-700:hover {
  background-color: #374151;
}

.text-sm {
  font-size: 0.875rem;
}

.space-y-6 > * + * {
  margin-top: 1.5rem;
}

.w-1\/3 {
  width: 33.333333%;
}

.w-2\/3 {
  width: 66.666667%;
}

.h-48 {
  height: 12rem;
}

.object-cover {
  object-fit: cover;
}

.overflow-hidden {
  overflow: hidden;
}

.relative {
  position: relative;
}

.absolute {
  position: absolute;
}

.top-4 {
  top: 1rem;
}

.left-4 {
  left: 1rem;
}

.bottom-4 {
  bottom: 1rem;
}

.flex {
  display: flex;
}

.items-center {
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}

.justify-center {
  justify-content: center;
}

.flex-wrap {
  flex-wrap: wrap;
}

.space-x-2 > * + * {
  margin-left: 0.5rem;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}
</style> 